import { Drawer, Toolbar, Box, useMediaQuery } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FIRST_AND_LAST_MILE_TABS } from './FirstAndLastMileTabsList';
import { cloneDeep, includes } from 'lodash';
import { DrawerList, DrawerCurrentUserStatus, DrawerAccountWelcome } from '../components';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { IRONER, USER_ROLES_TYPES, ZSHIP_ID } from 'src/constants';
import { useGetDeliverySettingQuery } from 'src/_api/authApi';
import { omitNestedObject } from 'src/_utils';
import { Paid } from '@mui/icons-material';
const drawerWidth = 260;

export default function MapitDrawer({ openDrawer, toggleDrawer }) {
    const { pathname } = useLocation();
    const profile = useSelector((state) => state.entities.profile.profile);

    const { data: deliverySetting } = useGetDeliverySettingQuery()

    const downLg = useMediaQuery(theme => theme.breakpoints.down('lg'));


    const tabs = useMemo(() => {
        let clone = cloneDeep(FIRST_AND_LAST_MILE_TABS)

        if (profile?.type !== USER_ROLES_TYPES.ADMIN) {
            clone = clone?.filter(el => el.title !== "Account")
        }

        if (!deliverySetting?.reschduleDeliveryDate) {
            if (!!deliverySetting?.ordersCount) return clone
            clone = omitNestedObject(clone, 'title', 'Rescheduled Orders');

        }

        if (!profile?.merchant?.onlinePayment) {
            clone = clone?.filter(el => el.href !== "/merchant/transactions")
        }

        if (!!profile?.merchant?.salla?.store_id || !!profile?.merchant?.zid?.store_id || [...IRONER].includes(profile?.merchant?.id)) {
            let index = clone?.findIndex(el => el.title === "Account")
            clone[index].children = clone[index]?.children?.filter(el => !["/merchant/account/plans", "/merchant/account/subscription"].includes(el.href))
        }

        if (profile?.merchant?.onlinePayment) {
            clone.splice(18, 0, {
                href: "/merchant/cod-invoices",
                icon: Paid,
                title: "COD Wallet",
            })
        }

        if (!clone?.merchant?.isNationalAddressEnabled) {
            clone = clone?.filter(el => !["/merchant/national-address-transactions"].includes(el.href))
        }

        return clone
    }, [profile, FIRST_AND_LAST_MILE_TABS, deliverySetting])

    useEffect(() => {
        if (downLg && openDrawer) {
            toggleDrawer();
        }
    }, [pathname, downLg]);

    return (
        <Drawer
            open={openDrawer}
            onClose={toggleDrawer}
            variant={downLg ? "temporary" : "permanent"}
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
            }}
        >
            <Toolbar />
            <Box sx={{ overflowY: 'auto', overflowX: 'hidden' }}>
                <DrawerAccountWelcome companyName={profile?.merchant?.companyName} logo={profile?.merchant?.logo} />
                {/* {
                    !!profile?.merchant?.currentStatus && includes(["BLOCKED", "WAITING", "PLAN_EXPIRED", "CARD_REQUIRED"], profile?.merchant?.currentStatus) &&
                    <DrawerCurrentUserStatus currentStatus={profile?.merchant?.currentStatus} />
                } */}
                <DrawerList tabs={tabs} />
            </Box>
        </Drawer>
    )
}